// extracted by mini-css-extract-plugin
export default {"healthPage":"Health_healthPage__a3nj7","listHero":"Health_listHero__yQHHC"};